import { Injectable } from '@angular/core';
import { AssetsListResponse } from '@archimed/models';
import { AssetsApiPort } from '../../application/ports/assets-api.port';

@Injectable()
export class MockAssetsApiAdapter implements AssetsApiPort {
  async getAssetDefinitions(): Promise<AssetsListResponse> {
    await this.delay(300);

    return {
      assetTypes: [
        {
          assetType: 'refinery',
          assetCount: 1,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'location', type: 'string' },
            { name: 'capacity', type: 'number' },
            { name: 'feedstock', type: 'string' },
          ],
          relationships: [
            { relationshipType: 'CONTAINS', targetAssetType: 'unit' },
            { relationshipType: 'CONTAINS', targetAssetType: 'pipeline' },
          ],
        },
        {
          assetType: 'unit',
          assetCount: 9,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'capacity', type: 'number' },
            { name: 'temperature', type: 'number' },
            { name: 'pressure', type: 'number' },
          ],
          relationships: [
            { relationshipType: 'CONTAINS', targetAssetType: 'tank' },
            { relationshipType: 'CONTAINS', targetAssetType: 'pipeline' },
            { relationshipType: 'CONTAINS', targetAssetType: 'equipment' },
            { relationshipType: 'PART_OF', targetAssetType: 'refinery' },
          ],
        },
        {
          assetType: 'tank',
          assetCount: 7,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'capacity', type: 'number' },
            { name: 'current_level', type: 'number' },
            { name: 'product', type: 'string' },
          ],
          relationships: [
            { relationshipType: 'FEEDS_INTO', targetAssetType: 'pipeline' },
            { relationshipType: 'PART_OF', targetAssetType: 'unit' },
          ],
        },
        {
          assetType: 'pipeline',
          assetCount: 4,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'diameter', type: 'number' },
            { name: 'length', type: 'number' },
            { name: 'material', type: 'string' },
          ],
          relationships: [
            { relationshipType: 'CONNECTS', targetAssetType: 'tank' },
            { relationshipType: 'CONNECTS', targetAssetType: 'unit' },
          ],
        },
        {
          assetType: 'flowmeter',
          assetCount: 9,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'range', type: 'number' },
            { name: 'accuracy', type: 'number' },
            { name: 'current_flow', type: 'number' },
          ],
          relationships: [
            { relationshipType: 'MONITORS', targetAssetType: 'tank' },
            { relationshipType: 'MONITORS', targetAssetType: 'pipeline' },
          ],
        },
        {
          assetType: 'equipment',
          assetCount: 2,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'vendor', type: 'string' },
            { name: 'protocol', type: 'string' },
            { name: 'redundancy', type: 'boolean' },
          ],
          relationships: [
            { relationshipType: 'CONTAINS', targetAssetType: 'sensor' },
            { relationshipType: 'PART_OF', targetAssetType: 'unit' },
          ],
        },
        {
          assetType: 'sensor',
          assetCount: 2,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'type', type: 'string' },
            { name: 'range', type: 'number' },
            { name: 'accuracy', type: 'number' },
          ],
          relationships: [
            { relationshipType: 'PART_OF', targetAssetType: 'equipment' },
            { relationshipType: 'REPORTS_TO', targetAssetType: 'controller' },
          ],
        },
        {
          assetType: 'controller',
          assetCount: 1,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'type', type: 'string' },
            { name: 'firmware_version', type: 'string' },
            { name: 'ip_address', type: 'string' },
          ],
          relationships: [
            { relationshipType: 'MONITORS', targetAssetType: 'sensor' },
            { relationshipType: 'CONTROLS', targetAssetType: 'equipment' },
          ],
        },
        {
          assetType: 'document',
          assetCount: 1,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'revision', type: 'string' },
            { name: 'approval_status', type: 'string' },
            { name: 'document_type', type: 'string' },
          ],
          relationships: [
            { relationshipType: 'DOCUMENTS', targetAssetType: 'unit' },
          ],
        },
        {
          assetType: 'report',
          assetCount: 1,
          properties: [
            { name: 'obid', type: 'string' },
            { name: 'object_name', type: 'string' },
            { name: 'format', type: 'string' },
            { name: 'frequency', type: 'string' },
            { name: 'report_type', type: 'string' },
          ],
          relationships: [
            { relationshipType: 'SUMMARIZES', targetAssetType: 'refinery' },
          ],
        },
      ],
      totalCount: 10,
    };
  }

  private delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
